import { FE_CATEGORY_LINK_SPECULATIVE_PREFETCHING_THRESHOLD_250204 } from "@faire/retailer-settings/FE_CATEGORY_LINK_SPECULATIVE_PREFETCHING_THRESHOLD_250204";
import { useSetting } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
export var useSettingCategoryLinkPrefetchingThresholdMs = function() {
    return useSetting(FE_CATEGORY_LINK_SPECULATIVE_PREFETCHING_THRESHOLD_250204);
};
